import OutBrain from "common/Layout/Adverts/OutBrain";
import CenterWrapper from "../CenterWrapper";
import { FC, useContext } from "react";
import { ArticleContext } from "../../Context";
import { articleTypes } from "../../Context/ArticleContext";

interface Props {
  type: string;
}

const ArticleFooter: FC<Props> = ({ type }) => {
  const { isDisableOutbrain, refactoredArticle } =
    useContext<articleTypes>(ArticleContext);

  if (type === "Service") {
    return null;
  }

  if (type === "Commercial") {
    return null;
  }

  if (isDisableOutbrain) {
    return null;
  }

  return (
    <>
      <CenterWrapper>
        <OutBrain id="AR_1" contentUrl={refactoredArticle?.url} />
      </CenterWrapper>
    </>
  );
};

export default ArticleFooter;
